export default __webpack_public_path__ + "static/media/artists-won.41efb03e.svg";